import { videoProductionServiceEndpoint } from "@/config/endpoints";
import axiosInstance from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";

export default function useCurrentService(
  serviceId: number | null | undefined | string
) {
  const query = useQuery({
    queryKey: ["video-production", "service", serviceId],
    queryFn: async () => {
      if (!serviceId) return null;
      const res = await axiosInstance.get(
        `${videoProductionServiceEndpoint}/${serviceId}`
      );
      return res.data?.videoService ?? res.data?.service ?? res.data ?? null;
    },
  });

  return {
    service: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
